var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useAppSelector } from '../../../components/app/hooks';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
/**
 * Default loading component
 * @param {number} numberOfLines - Number of lines in the skeleton loader
 * @param {number} height - Height of each line in the skeleton loader
 * @returns {JSX.Element} The default loading skeleton component
 */
export var DefaultLoadingComponent = function (_a) {
    var _b = _a.loaderComponentProps, loaderComponentProps = _b === void 0 ? {} : _b, _c = _a.loaderContainerProps, loaderContainerProps = _c === void 0 ? {} : _c, loaderProps = __rest(_a, ["loaderComponentProps", "loaderContainerProps"]);
    var defaultProps = {
        count: 1,
        height: 'auto',
    };
    var isLoaderEnabled = useAppSelector(function (state) { return state.loadingStore.isLoaderEnabled; });
    return (React.createElement("span", __assign({ style: loaderContainerProps.style || loaderProps.style }, __assign({}, loaderContainerProps)), isLoaderEnabled ? (React.createElement(Skeleton, __assign({}, __assign(__assign(__assign(__assign({}, defaultProps), loaderProps), loaderComponentProps), { style: loaderComponentProps.style || loaderProps.style })))) : (React.createElement("span", null))));
};
